import { Component, OnDestroy, OnInit } from '@angular/core';
import quotesHe from '../../assets/data/quotes-he.json';
import quotesEn from '../../assets/data/quotes-en.json';
import { LocalStorageService } from '../core/local-storage/local-storage.service';
import { LocalStorageKeys } from '../core/local-storage/local-storage.enum';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { LocaleEnum } from '../submit-lecture/lecture.values';


@Component({
  selector: 'login-quote',
  templateUrl: './login-quote.component.html',
  styleUrls: ['./login-quote.component.scss'],
})
export class LoginQuoteComponent implements OnInit, OnDestroy {

  public quotesList: {quote: string, by: string}[];
  public chosenQuote;
  public translate;
  private subscription: Subscription;


  constructor(private localStorageService: LocalStorageService,
              translate: TranslateService) {
                this.translate = translate;
               }

  ngOnInit(): void {
    let lang: string = this.localStorageService.read(LocalStorageKeys.language);
    lang = lang ? lang : LocaleEnum.HE;
    this.onLangChange(lang);

    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.onLangChange(event.lang);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private onLangChange(lang): void {
    switch (lang) {
      case LocaleEnum.HE:
        this.quotesList = quotesHe;
        break;
      case LocaleEnum.EN:
        this.quotesList = quotesEn;
        break;
    }
    const keys = Object.keys(this.quotesList);
    const randomKey = keys[Math.floor(Math.random() * keys.length)];
    this.chosenQuote = this.quotesList[randomKey];
  }

}
